import * as Api from '@Api/index';

import type { Query } from '@Types/Base';

async function queryProxi<T>(url: string, opts?: RequestInit, serverRequest?: Query) {
  const request = serverRequest || Api.getRequest();

  const encodedUrl = Api.createProxyUrl({ path: url, request });
  const res = await Api.query<T>({ path: encodedUrl, opts, request });

  return res;
}

export default queryProxi;
